import React from 'react';
import { MapBrazil } from 'react-brazil-map';
import styled from 'styled-components';

interface UserMapProps {
  districts: string[];
}

const MapContainer = styled.div<UserMapProps>`
  div svg {
    width: 100%;
  }

  div svg g a {
    pointer-events: none;
  }

  ${({ districts, theme }) =>
    districts.map(
      (district) =>
        `div svg g #${district} {
          path{
            fill: ${theme.colors.primary} !important;
            stroke: ${theme.colors.background_white} !important;
          }
          text {
            fill: ${theme.colors.background_white} !important;
          }
        }`,
    )}
`;

const UserMap: React.FC<UserMapProps> = ({ districts }: UserMapProps) => {
  return (
    <MapContainer districts={districts}>
      <MapBrazil bg="#E5E5E5" fill="#E5E5E5" colorStroke="white" />
    </MapContainer>
  );
};

export default UserMap;
